'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PUBLIC = exports.PUBLIC = 'PUBLIC';
var APP = exports.APP = 'APP';


//////////////////
// WEBPACK FOOTER
// ./js/constants/AuthType.js
// module id = 313
// module chunks = 3 4 5